import React, { useEffect, useState } from 'react';
import { Box, Button, Link as MatLink, styled } from '@mui/material';
import { HeaderLayout } from '../../HeaderLayout';
import { useTranslation } from 'react-i18next';
import { Link, useNavigate } from 'react-router-dom';
import { B2B_URL } from '../../../../utils/constans/constans';
import { LogoWrapperB2B } from '../../../shared/logos/LogoWrapperB2B';
import ShoppingCartOutlinedIcon from '@mui/icons-material/ShoppingCartOutlined';
import useShopifyCartSWR from '../../../../hooks/shopify/useShopifyCartSWR';
import storageService, { Locals } from '../../../../utils/storageService';
import { isNullOrUndefined } from '../../../../utils/utils';
import useCart from '../../../../hooks/cart/useCart';
import useUserSWR from '../../../../hooks/user/useUserSWR';


export const ProfileHeader: React.FC = () => {
    const { user } = useUserSWR();
    const { t } = useTranslation();
    const navigate = useNavigate();
    const cart_token = storageService.getItem(Locals.CART_TOKEN);
    const { cart, isLoading, isError, forceRefresh, isValidating } =
        useShopifyCartSWR(cart_token);
    const cartHook = useCart();

    useEffect(() => {
        if (!isLoading && !isValidating && isNullOrUndefined(cart)) {
            cartHook.createCart().then((elem) => {
                forceRefresh().then();
            });
        }
    }, [cart, isLoading, isValidating]);

    return (
        <>
            <HeaderLayout>
                <LogoWrapperB2B />
                <Box>
                    <Link to={'/cart'}>
                        <Button>
                            <ShoppingCartOutlinedIcon /> {t('HEADER.CART')} (
                            {cart ? cart.totalQuantity : 0})
                        </Button>
                    </Link>
                    <MatLink href={B2B_URL} underline="none">
                        <Button>{t('HEADER.SHOP')}</Button>
                    </MatLink>
                    {/*<Link*/}
                    {/*    onClick={() => navigate('/Quotation')}*/}
                    {/*    underline="none"*/}
                    {/*>*/}
                    {/*    <Button>{t('HEADER.QUOTATION')}</Button>*/}
                    {/*</Link>*/}
                    {user && user.is_admin && (
                        <>
                            <Link to={'/profile'}>
                                <Button>Profil</Button>
                            </Link>
                            <Link to={'/admin/users'}>
                                <Button>Admin</Button>
                            </Link>
                        </>
                    )}
                </Box>
            </HeaderLayout>
        </>
    );
};
